// extracted by mini-css-extract-plugin
module.exports = {"category-row":"category-row___GfBrT","category-header":"category-header___3AjC8","collapse-icon":"collapse-icon___15_Fl","opened":"opened___2VPUX"};